enum BenefitParticipationDecision {
  NoDecision ,
  OptedIn,
  OptedOut,
}

export default BenefitParticipationDecision
